import React from "react";
import { styled, css } from "styled-components";
import { Colors } from "../../styles/Colors";
const Container = styled.div `
  width: 100%;
  position: relative;
`;
const Background = styled.div `
  background: ${(props) => props.imageUrl};
  width: 100%;
  padding-bottom: 37.5%;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.33) 50%,
      rgba(255, 255, 255, 0) 100%
    ),
    url(${(props) => props.imageUrl}), #c4c4c4;
  background-size: cover;
  background-position: 50% 50%;
  border-radius: 5px 5px 0px 0px;
`;
const Title = styled.h2 `
  color: ${Colors.WHITE};
  position: absolute;
  left: 1em;
  top: 1em;
  margin: 0;
  padding: 0;
  font-weight: 500;
`;
const ChildContainer = styled.div `
  position: relative;
  width: 100%;
  ${({ offset }) => offset &&
    css `
      margin-top: ${offset}%;
    `}
}
`;
export const DestinationHeader = ({ title, imageUrl, childOffset, children }) => (React.createElement(Container, null,
    React.createElement(Background, { imageUrl: imageUrl }),
    React.createElement(Title, null, title),
    children && (React.createElement(ChildContainer, { offset: childOffset }, children))));
DestinationHeader.displayName = "DestinationHeader";
export default DestinationHeader;
//# sourceMappingURL=index.js.map